<template>
    <div v-if="tenant" class="debug-console">

        <v-app-bar
            color="#1d1f29"
            app
            dark
        >
            <v-btn
                class="h40 mr-2"
                plain
                @click="goBack"
            >
                Back
            </v-btn>
        </v-app-bar>

        <v-main>
            <div class="content">
                <v-textarea
                    v-model="expression"
                    filled
                    hide-details
                    :rows="4"
                    label="Expression"
                    style="font-family: 'Courier New', monospace; font-weight: 600;"
                    @keydown.prevent.enter="runExpression"
                />

                <div class="text-center">
                    <v-btn
                        class="mx-2 mt-4"
                        color="primary"
                        outlined
                        @click="runExpression"
                    >
                        Run Expression
                    </v-btn>
                    <v-btn
                        class="mx-2 mt-4"
                        color="primary"
                        outlined
                        @click="forceSync"
                    >
                        Force Sync
                    </v-btn>
                    <v-btn
                        class="mx-2 mt-4"
                        color="primary"
                        outlined
                        @click="forceSyncFromNativeStore"
                    >
                        Sync From Native Store
                    </v-btn>
                    <v-btn
                        class="mx-2 mt-4"
                        color="primary"
                        outlined
                        @click="resetSyncInProgress"
                    >
                        Reset SyncInProgress
                    </v-btn>
                </div>

                <div
                    v-if="result"
                    class="mt-4"
                    style="font-size: 12px; background-color: #fafafa; padding: 10px; border-radius: 3px;"
                >
                    <pre>{{ result }}</pre>
                </div>
            </div>
        </v-main>

    </div>
</template>

<script>
import { mapActions } from 'vuex'
import store from '@/store';
import * as mutationTypes from '@/store/mutationTypes';

export default {
    name: 'DebugConsole',

    beforeRouteEnter(to, from, next) {
        if(store.getters.appConfig.general.dcp !== to.query.token) {
            next({ name: 'userLogin' });
        }

        next()
    },

    created() {
        this.$router.replace({ name: 'debugConsole' })
    },

    data() {
        return {
            expression: null,
            result: null,
        };
    },

    computed: {
    },

    methods: {
        ...mapActions(['sync', 'syncFromNativeStore']),

        runExpression() {
            try {
                this.result = eval(this.expression)
            } catch(error) {
                this.result = error.message
            }
        },

        async forceSync() {
            try {
                const syncResult = await this.sync()
                this.result = syncResult.details
            } catch(error) {
                this.result = error.details
            }
        },

        async forceSyncFromNativeStore() {
            try {
                const syncResult = await this.syncFromNativeStore()
                this.result = syncResult.details
            } catch(error) {
                this.result = error.details
            }
        },

        resetSyncInProgress() {
            this.$store.commit(mutationTypes.SET_SYNC_IN_PROGRESS, { syncInProgress: false });
        },

        goBack() {
            this.$router.replace({ name: 'userLogin' });
        }
    }
};
</script>

<style lang="scss" scoped>
.debug-console {
    height: 100%;

    .v-main {
        height: 100%;

        .content {
            padding: 20px;
        }
    }
}
</style>
